/* eslint-disable no-undef */

export default {
  data() {
    return {
      loginType: this.$val.LoginWay.email,
      codeIndex: 0,
    };
  },

  computed: {
    isEmail() {
      let reg = /@/;
      let acn = this.accountName;

      return reg.test(acn);
    },

    // 验证码发送方法
    codeRequestFunc() {
      return !this.isEmail
        ? this.$axios.SendCommonPhoneCode
        : this.$axios.SendCommonEmailCode;
    },

    // 绑定手机/邮箱
    bindCodeFunc() {
      return !this.isEmail
        ? this.$axios.Account_bindPhone
        : this.$axios.Account_bindEmail;
    },
  },

  methods: {
    onChangeLoginType(value) {
      this.loginType = value;
      this.codeIndex++;
    },

    onClickSendPhoneCode(next) {
      // var that = this;
      // console.log("1");
      var _values = {};
      this.form.validateFields(
        ["phone_area", "phone"],
        (errors, values) => {
          // console.log("validateFields", errors, values);
          if (values.phone) {
            values.sms_tpl = this.$val.SendCodeDefaultValue.phone;
            // values.phone_code = '86'
          }
          if (!errors) {
            
            // captcha.showCaptcha();
            _values = values;
            // console.log("return",_values);
          }
        }
      );
      
      initAlicom4(
        {
          captchaId: "5b1279371f9674ccd57a01328396bbd5",
          product: "bind",
        },
        function(captcha) {
          captcha
            .onReady(function() {})
            .onSuccess(function() {
              // console.log(Date.now())
              var code = BigInt(Date.now()) ^ BigInt(1712345678901);
              _values.phone_code = btoa(String(code));
              // console.log("next",_values);
              
              next(_values);
              var result = captcha.getValidate();
              if (!result) {
                // return alert('完成验证');
              }
            })
            .onError(function() {});
            if (_values.phone) {
              captcha.showCaptcha();
            }
          
        }
      );
    },

    onClickSendCode(next) {
      this.form.validateFields(
        ["phoneOrEmail", "phone_area"],
        (errors, values) => {
          if (!this.isEmail || values.phone) {
            values.sms_tpl = this.$val.SendCodeDefaultValue.phone;
            values.phone = values.phoneOrEmail;
          } else {
            values.email_tpl = this.$val.SendCodeDefaultValue.email;
            values.email = values.phoneOrEmail;
          }

          if (!errors) {
            initAlicom4(
              {
                captchaId: "5b1279371f9674ccd57a01328396bbd5",
                product: "bind",
              },
              function(captcha) {
                captcha
                  .onReady(function() {})
                  .onSuccess(function() {
                    var code = BigInt(Date.now()) ^ BigInt(1712345678901);
                    values.phone_code = btoa(String(code));
                    next(values);
                    var result = captcha.getValidate();
                    if (!result) {
                      // return alert('完成验证');
                    }
                  })
                  .onError(function() {});
                  if (values.phone) {
                    captcha.showCaptcha(); 
                  }
              }
            );
          }
        }
      );
    },
    // onSend(captcha){
    //   this.form.validateFields(
    //     ["phoneOrEmail", "phone_area"],
    //     (errors, values) => {
    //       console.log("validateFields", errors, values);
    //       if (!this.isEmail || values.phone) {
    //         values.sms_tpl = this.$val.SendCodeDefaultValue.phone;
    //         values.phone = values.phoneOrEmail;
    //       } else {
    //         values.email_tpl = this.$val.SendCodeDefaultValue.email;
    //         values.email = values.phoneOrEmail;
    //       }

    //       if (!errors) {
    //         // next(values);
    //         captcha.showCaptcha();
    //         console.log("return--",values);
    //         return values;
    //       }
    //     }
    //   );
    // },
    onSendSuccess(data) {
      if (data && data.code == 0) {
        this.$message.success("已成功发送验证码");
        this.showSuccessTip = true;
        this.transaction_id = data.data.transaction_id;
      }
    },

    onCountDownFinished() {
      this.showSuccessTip = false;
    },
  },
};
